module.exports = "/* .header{\r\n    text-align: center;\r\n} */\r\n/* .header{\r\n    height: 120px;\r\n} */\r\n/* img{    \r\n   margin-left: 100px;\r\n} */\r\naddress{\r\n    margin-right: 100px;\r\n    text-align: center;\r\n    margin-bottom: -5px;\r\n}\r\nimg{\r\n    max-width:100%;\r\n    width:100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/header/header.component.css
// module id = ./src/app/common/header/header.component.css
// module chunks = main